import { For, Show } from "solid-js";

import Empty from "@/components/Base/Empty/Index";
import GameItem from "@/components/Base/GameItem/IndexTemplete";
import GameList from "@/components/Base/GameList";
import { SearchSportItem } from "@/components/PC/Modals/GlobalSearch/SearchSportItem";
import { globalSearch, useGlobalSearch } from "@/hooks/useGlobalSearch";
import { isMobile } from "@/lib/isMobile";
import { SportEventInfo } from "@/types/swagger/extGame";

type SearchPreviewItemProps = {
  fetchGames: (isLoadMore?: boolean) => Promise<void>;
};

export const SearchPreviewItem = (props: SearchPreviewItemProps) => {
  const { closeGlobalSearchModal } = useGlobalSearch();

  // 结合 List 组件的 loadMore 函数
  const loadMoreHandler = async () => {
    if (
      globalSearch().gameList?.length >= globalSearch().gameListCount ||
      globalSearch().isSearching ||
      globalSearch().isInit
    )
      return;

    await props.fetchGames(true);
  };

  return (
    <div
      class="w-full"
      classList={{
        "pb-[160px]": isMobile(),
        // "h-[508px]": !isMobile() && globalSearch().curMainCategory === "Casino",
        // "h-[600px]": !isMobile() && globalSearch().curMainCategory === "Sports",
      }}
    >
      <Show when={globalSearch().curMainCategory === "Casino"} fallback={<></>}>
        <GameList
          loadMore={loadMoreHandler}
          finish={
            globalSearch().gameList?.length >= globalSearch().gameListCount
          }
          currentCount={globalSearch().gameList?.length}
          totalCount={globalSearch().gameListCount}
          apiLoading={globalSearch().isSearching}
        >
          <Show
            when={globalSearch().gameList?.length > 0}
            fallback={<Empty class="pt-[160px]" />}
          >
            <div
              class="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8"
              classList={{
                "gap-[7.5px]": isMobile(),
                "gap-[12px]": !isMobile(),
              }}
            >
              <For each={globalSearch().gameList ?? []}>
                {(item) =>
                  "game_id" in item ? (
                    <div onClick={closeGlobalSearchModal}>
                      <GameItem
                        gameId={item.game_id}
                        game={item}
                        radius={6.29}
                      />
                    </div>
                  ) : null
                }
              </For>
            </div>
          </Show>
        </GameList>
      </Show>

      <Show when={globalSearch().curMainCategory === "Sports"} fallback={<></>}>
        <GameList
          loadMore={loadMoreHandler}
          finish={
            globalSearch().gameList?.length >= globalSearch().gameListCount
          }
          currentCount={globalSearch().gameList?.length}
          totalCount={globalSearch().gameListCount}
          apiLoading={globalSearch().isSearching}
        >
          <Show
            when={globalSearch().gameList?.length > 0}
            fallback={<Empty class="pt-[160px]" />}
          >
            <div class="grid grid-cols-1 gap-x-[10px] gap-y-[12px] pb-[12px] md:grid-cols-2 xl:grid-cols-3">
              <For each={globalSearch().gameList ?? []}>
                {(item) => (
                  <div onClick={closeGlobalSearchModal}>
                    <SearchSportItem
                      item={item as SportEventInfo & { IsLive: boolean }}
                    />
                  </div>
                )}
              </For>
            </div>
          </Show>
        </GameList>
      </Show>
    </div>
  );
};
